<template>
    <div>

        <van-cell-group title="贷款账号" v-if="dataList1.length>0">
            <van-cell v-for="(item, index) in dataList1"
                      :key="index"
                      :title="item.jkhtbh"
                      is-link
                      @click="getData(item.jkhtbh)"
            />
        </van-cell-group>

        <ul class="thead"  v-show="dataList.length>0">
            <li>序号</li>
            <li>期数</li>
            <li>还款日期</li>
            <li>应还本金</li>
            <li>应还利息</li>
            <li>本息合计</li>
        </ul>

        <van-cell-group v-show="dataList.length>0">
            <van-cell v-for="(item, index) in dataList"
                :key="index"
            >
                <ul class="list-item">
                    <li>{{index+1}}</li>
                    <li>{{item.qs}}</li>
                    <li>{{item.jhhkrq}}</li>
                    <li>{{item.yhbj}}</li>
                    <li>{{item.yhlx}}</li>
                    <li>{{item.hkhj}}</li>
                </ul>
            </van-cell>
        </van-cell-group>


    </div>
</template>

<script>
    import {Cell, CellGroup, List} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/list/style';

    export default {
        name: 'repaymentPlan',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanList: List,
        },
        mounted(){

        },
        data(){
            return {
                //van-list
                dataList: [],
                loading: false,
                finished: false,
                loanAccountNumber: '', //借款合同号
                startResult: 1,
                endResult: 9999,
                startdate: (new Date().getFullYear()) + '-' + (new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1) + '-' + (new Date().getDate() < 10 ? '0'+new Date().getDate() : new Date().getDate()),
                enddate: (new Date().getFullYear()+1) + '-' + (new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1) + '-' + (new Date().getDate() < 10 ? '0'+new Date().getDate() : new Date().getDate()),

                dataList1: [],
            }
        },
        created(){
            this.loanAccountNumber = this.$route.query.account;
            this.getD1();
        },
        methods: {
            getD1(){
                let self = this,
                    url = this.url;
                console.log(url );
                self.$http.post('/miapp/A2009/mpaasgatewayunencrypted' , {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                        zjhm: self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        if(res.result.length > 0){
                            self.dataList1 = res.result;
                        } else {
                            self.$utils.alert('未查询到贷款账户号');
                        }
                    } else {
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            getData(arg){
                let self = this;
                self.$http.post('/miapp/A5005/mpaasgatewayunencrypted', {
                    ybmapMessage: {
                        cxlx: '03',
                        cxlxz: self.loanAccountNumber,
                        zjhm: self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.idCard,
                        jkhth: arg,
                        startResult: self.startResult,
                        endResult: self.endResult,
                        startdate: self.startdate,
                        enddate: self.enddate,
                        ispaging: 0
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        self.dataList = res.result;
                    } else {
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    console.log("error", res);
                });
            }
        }
    }
</script>

<style>
    body {background:#e5e5e5;}
</style>
<style lang="stylus" scoped>
    .thead
        background #666666
        width 100%
        color #ffffff
        display flex
        li
            font-size .3rem
            line-height 1rem
            text-align center
            &:first-child
                width 10%
            &:nth-child(2)
                width 10%
            &:nth-child(3)
                width 22%
            &:nth-child(4)
                width 20%
            &:nth-child(5)
                width 20%
            &:last-child
                width 18%
    .list-item
        background #ffffff
        display flex
        width 100%
        color #333333
        li
            font-size .3rem
            text-align center
            &:first-child
                width 10%
            &:nth-child(2)
                width 10%
            &:nth-child(3)
                width 22%
            &:nth-child(4)
                width 20%
            &:nth-child(5)
                width 20%
            &:last-child
                width 18%
    .van-cell
        padding-left 0
        padding-right 0
    .van-cell:not(:last-child)::after
        left 0
</style>